// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ConsoleSqlOutlinedSvg from "@ant-design/icons-svg/es/asn/ConsoleSqlOutlined";
import AntdIcon from '../components/AntdIcon';

var ConsoleSqlOutlined = function ConsoleSqlOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ConsoleSqlOutlinedSvg
  }));
};

ConsoleSqlOutlined.displayName = 'ConsoleSqlOutlined';
export default React.forwardRef(ConsoleSqlOutlined);